module.exports = require('./helpers/bundle-url').getBundleURL('e1ick') + "logo-dark.eefe0b7f.svg";